export enum BLHealthModal {
  AddToCart = 'AddToCart',
  AddToRegistry = 'AddToRegistry',
}
